<template>
  <div id="container">
    <!--  excel表格上传  -->
    <el-upload
      class="upload-demo"
      drag
      action="``"
      multiple
      accept=".xlsx"
      :on-exceed="exceed"
      :limit="1"
      :on-remove="remove"
      :http-request="uploadFile"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        将文件拖到此处，或
        <em>点击上传</em>
      </div>
      <div
        class="el-upload__tip"
        slot="tip"
      >1次只能上传1个xls文件
      </div>
    </el-upload>
    <el-progress :percentage="progress"></el-progress>
    <!--  上传的excel表格预览  -->
    <div
      class="preview-excel"
      style="margin-top: 20px;"
    >
      <div style="height: 600px;overflow-y: auto">
        <table
          border="1"
          style="width:100%;border-collapse: collapse"
        >
          <thead>
          <tr>
            <th
              v-for="(item,index) in Object.keys(sheetArray[0] || {})"
              :key="index"
            >{{item}}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="(item,idx) in sheetArray"
            :key="idx"
          >
            <td
              v-for="(childrenitem,ex) in Object.values(item)"
              :key="ex"
              :class="tableCellClassNameex(item,ex)"
            >{{childrenitem}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <el-table
        :data="sheetArray"
        border
        height="600px"
        v-if="sheetArray.length"
        @cell-click="handleCellClick"
        :header-cell-class-name="headerRowClassName"
        :cell-class-name="tableCellClassName"
      >
        <el-table-column
          type="index"
          width="50"
        >
        </el-table-column>
        <el-table-column
          v-for="(item,index) in  Object.keys(sheetArray[0] || {})"
          :label="item"
          :key="index"
          :prop="item"
        >
          <template v-slot="{ row }">
            <div v-if="inputable.find(ipt => ipt === item)">
              <el-input
                v-model="row[item]"
                size="mini"
                class="editRemarkInput"
              ></el-input>
            </div>
            <div v-else-if="dropDownSelection.find(ipt => ipt.name === item)">
              <el-select
                value-key="value"
                v-model="row[item]"
              >
                <el-option
                  v-for="options in dropDownSelection.find(ipt => ipt.name === item).optionValue"
                  :key="options"
                  :value="options"
                  :label="options"
                ></el-option>
              </el-select>
            </div>
            <div v-else>
              {{row[item]}}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        class="listTable_ele"
        :data="listTable"
        border
        height="250"
        style="width:100%"
        :cell-class-name="tableCellClassName"
      >
        <el-table-column
          v-for="item in tableField"
          :key="item.name"
          :prop="item.name"
          :label="item.label"
        >
          <template slot-scope="{row}">
            <div>
              <span v-if="item.disable">{{row[item.name]}}</span>
              <el-input
                v-else-if="item.valueOption.length === 0"
                v-model="row[item.name]"
                size="mini"
                class="editRemarkInput"
              ></el-input>
              <el-select
                value-key="value"
                v-else-if="item.valueOption.length !== 0"
                v-model="row[item.name]"
              >
                <el-option
                  v-for="options in item.valueOption"
                  :key="options.value"
                  :value="options"
                  :label="options"
                ></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-button
      @click="save"
      type="primary"
      style="margin-top: 20px"
    >保存
    </el-button>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import * as NP from 'number-precision'
import { deepClone } from '@/util'

export default {
  name: 'test',
  props: {
    disableProp: {
      type: Array,
      default: () => ['payMethods']
    },
    inputable: {
      type: Array,
      default: () => ['备注', '申请人']
    },
    dropDownSelection: {
      type: Array,
      default: () => [{
        name: '*付款结果',
        optionValue: ['付款成功', '付款失败']
      }]
    },
    requiredArray: {
      type: Array,
      default: () => ['*付款结果', '备注']
    },
    tableField: {
      type: Array,
      default: () => {
        return [
          {
            label: '备注',
            name: 'mark',
            disable: true
          },
          {
            label: '付款方式',
            name: 'payMethods',
            type: 'select',
            valueOption: [
              '银行转账',
              '承兑汇票'
            ]
          },
          {
            label: '付款状态',
            name: 'payStatus',
            type: 'input',
            valueOption: []
          }
        ]
      }
    }
  },
  data () {
    return {
      listTable: [],
      editable: [],
      sheetArray: [],
      progress: 0
    }
  },
  methods: {
    // 解析excel
    async uploadFile (params) {
      const _file = params.file
      const fileReader = new FileReader()
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result
          const { tableField } = this
          const workbook = XLSX.read(data, {
            type: 'binary',
            cellDates: true,
            dateNF: 'yyyy-MM-dd hh:mm'
          })
          for (const sheet in workbook.Sheets) {
            // 循环读取每个文件
            const sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets[sheet])
            const sheetLength = sheetArray.length
            // 若当前sheet没有数据，则continue
            if (sheetArray.length === 0) {
              continue
            }
            if (sheetArray.length > 5000) {
              // sheetArray = sheetArray.splice(0, 5000)
            }
            this.sheetArray = sheetArray.map(item => {
              const row = {}
              for (const key in item) {
                const obj = tableField.find(ex => ex.label === key)
                if (obj) {
                  Object.assign(row, {
                    [obj.name]: item[key]
                  })
                }
              }
              this.listTable.push(row)
              return item
              const t = new Date(item['价格有效期'])
              return Object.assign(item, {
                价格有效期: `${t.getFullYear()}-${t.getMonth() + 1}-${t.getDate()} ${t.getHours()}:${t.getMinutes()}`
              })
            })
            // sheetArray.forEach((item, index) => {
            //   const row = {}
            //   for (const key in item) {
            //     const obj = tableField.find(ex => ex.label === key)
            //     if (obj) {
            //       Object.assign(row, {
            //         [obj.name]: item[key]
            //       })
            //     }
            //   }
            //   this.listTable.push(row)
            // })
            // this.sheetArray = sheetArray.splice(0, 500)
            setTimeout(() => {
              this.progress = 50
              this.$nextTick(() => {
                // this.sheetArray.push(...sheetArray.splice(500,2000))
                this.progress = 100
              })
            }, 500)
          }
        } catch (e) {
          this.$message.error('文件解析错误！')
        }
      }
      fileReader.readAsBinaryString(_file)
    },
    // 上传1个以上文件时弹窗提示错误
    exceed: function () {
      this.$message.error('最多只能上传1个xls文件')
    },
    // 删除文件
    remove () {
      this.listTable = []
      this.sheetArray = []
    },
    handleCellClick (row, column, cell, event) {

    },
    save () {
      this.sheetArray = deepClone(this.sheetArray)
    },
    headerRowClassName ({ row, column, rowIndex, columnIndex }) {
      if (this.requiredArray.includes(column.label)) {
        return 'required'
      }
    },
    tableCellClassName ({ row, column, rowIndex, columnIndex }) {
      if ((row.mark || row['备注']) && column.label === '备注') {
        return 'error'
      }
      return ''
    },
    tableCellClassNameex (row, index) {
      const keys = Object.keys(row)
      if (keys[index] === '备注' && row['备注']) {
        return 'error'
      }
      return ''
    }
  }
}
</script>

<style
  scoped
  lang="less"
>
  /deep/ .editRemarkInput {
    input {
      border: 0 !important;
    }

    input:focus {
      border: 1px solid #409EFF !important;
    }
  }

  .tb-edit .input-box {
    display: none
  }

  .tb-edit .current-cell .input-box {
    display: block;
    margin-left: -15px;
  }

  /deep/ .required .cell {
    color: red !important;

    &::before {
      display: none;
    }
  }

  table th, table td {
    padding: 5px;
  }

  /deep/ .error {
    border: 1px dashed red !important;
  }
</style>
